export { default } from './use-scroll-to-top';
